import { IconButton, TableCell, Typography } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import { format } from "date-fns";
import React from "react";
import { useQuery } from "react-query";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

import { Amount } from "../../../../components/amount";
import { Async } from "../../../../components/Async";
import { ListTable } from "../../../../components/list_table";
import { QUERY_KEYS } from "../../../../constants";
import { fixAmount } from "../../../../core/utils";
import { ROUTES } from "../../../../routes";
import { calcCleanWeightFromTransaction } from "../../../product/utils";
import { isBasicTransaction, isLastProductTransaction, ITransaction } from "../../data/entities";
import { filterToQueryParams } from "../../data/filter";
import { transactionTypeToString } from "../../data/models";
import { TransactionRepoImpl } from "../../data/repo";
import { calcTransactionListSummary, isPlusTransaction } from "../../utils";
import { transactionRedux } from "../state/state";
import { initialFilter } from "./transaction_filter";

interface IProps {}

export const TransactionList: React.FC<IProps> = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const search = location.search || `?${filterToQueryParams(initialFilter)}`;
  const asyncTransactionList = useQuery([QUERY_KEYS.transactionList, search], () =>
    TransactionRepoImpl.getList(search),
  );

  async function deleteTransaction(id: string) {
    await dispatch(transactionRedux.actions.delete(id));
    dispatch(transactionRedux.actions.getList(search));
  }

  return (
    <Async
      asyncData={asyncTransactionList}
      renderSuccess={(transactionList) => {
        return (
          <ListTable<ITransaction>
            branch={transactionList}
            route={ROUTES.transaction}
            renderHeader={() => (
              <>
                <TableCell>Tarix</TableCell>
                <TableCell>Klient</TableCell>
                <TableCell>Tip</TableCell>
                <TableCell>Məbləğ</TableCell>
                <TableCell>Mal</TableCell>
                <TableCell>Xərc</TableCell>
                <TableCell>Qazanc</TableCell>
                <TableCell>Çirkli çəki</TableCell>
                <TableCell>Təmiz çəki</TableCell>
                <TableCell>Qiymət</TableCell>
                <TableCell>Actions</TableCell>
              </>
            )}
            renderRow={(transaction) => {
              const cleanWeight = calcCleanWeightFromTransaction(transaction);
              const isPlus = isPlusTransaction(transaction);
              const canDelete =
                isBasicTransaction(transaction) || isLastProductTransaction(transaction, transactionList);

              return (
                <>
                  <TableCell>{format(transaction.createdDate, "d MMM yyyy")}</TableCell>
                  <TableCell>{transaction.client?.name}</TableCell>
                  <TableCell>{transactionTypeToString(transaction.type)}</TableCell>
                  <TableCell>
                    <Typography
                      style={{
                        color: isPlus === true ? "green" : isPlus === false ? "red" : "",
                      }}
                    >
                      {isPlus === true ? "+" : isPlus === false ? "-" : ""}
                      {fixAmount(transaction.amount)} AZN
                    </Typography>
                  </TableCell>
                  <TableCell>{transaction.product?.name}</TableCell>
                  <TableCell>{transaction.expense?.name}</TableCell>
                  <TableCell>
                    <Amount amount={transaction.income} />
                  </TableCell>
                  <TableCell>{transaction.dirtyWeight && `${fixAmount(transaction.dirtyWeight)} kq`}</TableCell>
                  <TableCell>{cleanWeight && `${cleanWeight} kq`}</TableCell>
                  <TableCell>{cleanWeight && `${fixAmount(transaction.amount / cleanWeight)} AZN`}</TableCell>
                  <TableCell
                    align="right"
                    padding="none"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    {canDelete && (
                      <IconButton onClick={() => deleteTransaction(transaction.id)}>
                        <DeleteIcon />
                      </IconButton>
                    )}
                  </TableCell>
                </>
              );
            }}
            renderSummary={() => {
              const summary = calcTransactionListSummary(transactionList);

              return (
                <>
                  <TableCell colSpan={4}>Toplam:</TableCell>
                  <TableCell colSpan={3}>{fixAmount(summary.amount)} AZN</TableCell>
                  <TableCell>
                    <Amount amount={summary.income} />
                  </TableCell>
                  <TableCell>{fixAmount(summary.dirtyWeight)} kq</TableCell>
                  <TableCell colSpan={3}>{fixAmount(summary.cleanWeight)} kq</TableCell>
                </>
              );
            }}
          />
        );
      }}
    />
  );
};
